import { Link } from "react-router-dom";
import Wordmark from "@/components/Wordmark";

const cols = [
  {
    title: "Explore",
    links: [
      { label: "Destinations", to: "/destinations", id: "footer-destinations" },
      { label: "Stays", to: "/stays", id: "footer-stays" },
      { label: "Travel Tools", to: "/#tools", id: "footer-tools" },
      { label: "Trip Planning", to: "/#planning", id: "footer-planning" },
    ],
  },
  {
    title: "The Brand",
    links: [
      { label: "About", to: "/about", id: "footer-about" },
      { label: "Journal", to: "/#journal", id: "footer-journal" },
      { label: "Affiliate Disclosure", to: "/affiliate-disclosure", id: "footer-disclosure" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-ivory relative grain-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Wordmark dark />
            <p className="mt-6 text-sm leading-relaxed text-ivory/70 max-w-sm">
              Venture &amp; Stay independently researches travel recommendations to help you make confident
              choices. When you book through selected links, we may earn a commission at no additional cost to you.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <h4 className="text-xs tracking-[0.22em] uppercase text-gold font-semibold">{c.title}</h4>
              <ul className="mt-5 space-y-3">
                {c.links.map((l) => (
                  <li key={l.id}>
                    <Link
                      to={l.to}
                      data-testid={l.id}
                      className="text-sm text-ivory/75 hover:text-gold transition-colors duration-300"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="md:col-span-3">
            <h4 className="text-xs tracking-[0.22em] uppercase text-gold font-semibold">Contact</h4>
            <a
              href="mailto:Ventureandstay@gmail.com"
              data-testid="footer-contact-email"
              className="mt-5 inline-block text-sm text-ivory/75 hover:text-gold transition-colors duration-300"
            >
              Ventureandstay@gmail.com
            </a>
            <p className="mt-4 text-xs text-ivory/50 leading-relaxed">
              Reader questions and partnership enquiries welcome.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="https://www.tiktok.com/@ventureandstay"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-tiktok"
                aria-label="Venture & Stay on TikTok"
                className="group inline-flex h-10 w-10 items-center justify-center rounded-full border border-ivory/25 text-ivory/75 transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/ventureandstayugc"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-instagram"
                aria-label="Venture & Stay on Instagram"
                className="group inline-flex h-10 w-10 items-center justify-center rounded-full border border-ivory/25 text-ivory/75 transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
                  <path d="M12 2.16c3.2 0 3.58.01 4.85.07 3.25.15 4.77 1.69 4.92 4.92.06 1.27.07 1.65.07 4.85 0 3.2-.01 3.58-.07 4.85-.15 3.23-1.66 4.77-4.92 4.92-1.27.06-1.64.07-4.85.07-3.2 0-3.58-.01-4.85-.07-3.26-.15-4.77-1.7-4.92-4.92-.06-1.27-.07-1.64-.07-4.85 0-3.2.01-3.58.07-4.85C2.38 3.92 3.9 2.38 7.15 2.23 8.42 2.18 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 2.7.27.27 2.69.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.2 4.36 2.62 6.78 6.98 6.98 1.28.06 1.69.07 4.95.07s3.67-.01 4.95-.07c4.35-.2 6.78-2.62 6.98-6.98.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95C23.78 2.7 21.36.27 17 .07 15.67.01 15.26 0 12 0zm0 5.84A6.16 6.16 0 1 0 18.16 12 6.16 6.16 0 0 0 12 5.84zM12 16a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm6.41-11.85a1.44 1.44 0 1 0 1.44 1.44 1.44 1.44 0 0 0-1.44-1.44z" />
                </svg>
              </a>
            </div>
            <p className="mt-3 text-xs text-ivory/50">
              @ventureandstay on TikTok · @VentureandStayUGC on Instagram
            </p>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-ivory/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-ivory/50" data-testid="footer-copyright">
            © {new Date().getFullYear()} Venture &amp; Stay. Better journeys, thoughtfully planned.
          </p>
          <Link
            to="/affiliate-disclosure"
            data-testid="footer-disclosure-bottom"
            className="text-xs text-ivory/50 hover:text-gold transition-colors duration-300 underline underline-offset-4"
          >
            How our affiliate partnerships work
          </Link>
        </div>
      </div>
    </footer>
  );
}
